import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { FaIconComponent, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
  NgSelectModule,
} from "@ng-select/ng-select";
import { ArticleTemplate, Warehouse } from "src/app/_models";

import { CdkMenuModule } from "@angular/cdk/menu";
import { OverlayModule } from "@angular/cdk/overlay";
import { Component, OnInit, inject } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { ArticleService, WarehouseService } from "src/app/_services";
import { DateInputModule } from "../_shared/date-input";
import { MatNativeDateModule } from "@angular/material/core";
import { addDays, format as formatDate, startOfWeek } from "date-fns";

@Component({
  selector: "hawk-delivery-note-search-form",
  templateUrl: "./delivery-note-search-form.component.html",
  styleUrls: ["./delivery-note-search-form.component.scss"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgSelectComponent,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    FaIconComponent,
    RouterLink,
    RouterModule,
    NgSelectModule,
    FontAwesomeModule,
    CdkMenuModule,
    OverlayModule,
    DateInputModule,
    MatNativeDateModule,
  ],
  host: {
    class: "app-page",
  },
})
export class DeliveryNoteSearchFormComponent implements OnInit {
  private fb = inject(FormBuilder);
  public productCategories: any[] = [];
  public products: ArticleTemplate[] = [];
  public warehouses: Warehouse[] = [];
  public statusList: any[] = [
    { id: "PREPARED", description: "Vorbereitet" },
    { id: "SHIPPED", description: "Versandt" },
    { id: "DELIVERED", description: "Zugestellt" },
    { id: "RECEIPT", description: "Quittiert" },
  ];
  public searchTerm: string = "";

  public form = this.fb.group({
    number: new FormControl(),
    product_category: new FormControl(),
    status_id: new FormControl(),
    product_id: new FormControl(),
    sender_city: new FormControl(),
    rma: new FormControl(),
    sender_warehouse_id: new FormControl(),
    recipient_warehouse_id: new FormControl(),
    serial_number: new FormControl(),
    recipient_city: new FormControl(),
    create_date_from: new FormControl(),
    create_date_to: new FormControl(),
  });

  protected startDate: string;
  protected endDate: string;
  protected debugDate(value: any) {
    console.log("debugDate", value);
  }
  constructor(
    private router: Router,
    private articleService: ArticleService,
    private warehouseService: WarehouseService,
  ) {}

  ngOnInit(): void {
    this.articleService.loadArticleTemplates().subscribe({
      next: (data) => {
        this.products = data.sort((a, b) => a.description.localeCompare(b.description));
        this.productCategories = [...new Set(this.products.map((p) => p.product_category).filter((c) => c))].sort(
          (a, b) => a.localeCompare(b),
        );
      },
      error: (err) => {
        console.error(err);
      },
    });

    this.loadWarehouses();
  }

  private loadWarehouses() {
    this.warehouseService.loadWarehouses({ address_detail: true }).subscribe({
      next: (warehouses) => {
        this.warehouses = warehouses;
      },
      error: (error) => {
        console.log("error", error);
      },
    });
  }

  public search() {
    const formdata = this.form.value;

    const params = {
      number: formdata.number,
      product_category: formdata.product_category,
      status_id: formdata.status_id,
      product_id: formdata.product_id,
      sender_warehouse_id: formdata.sender_warehouse_id,
      recipient_warehouse_id: formdata.recipient_warehouse_id,
      sender_city: formdata.sender_city,
      rma: formdata.rma,
      serial_number: formdata.serial_number,
      recipient_city: formdata.recipient_city,
      create_date_from: formdata.create_date_from ? formatDate(formdata.create_date_from, "yyyy-MM-dd") : null,
      create_date_to: formdata.create_date_to ? formatDate(formdata.create_date_to, "yyyy-MM-dd") : null,
    };

    this.router.navigate(["lieferscheine", "suche"], { queryParams: params });
  }

  public clearDate() {
    this.form.controls.create_date_from.setValue(null);
    this.form.controls.create_date_to.setValue(null);
  }

  public setRange(range: string) {
    let start: any;
    let end: any;
    switch (range) {
      case "today":
        start = addDays(new Date(), 0);
        end = addDays(new Date(), 0);
        break;
      case "thisweek":
        start = startOfWeek(new Date(), { weekStartsOn: 1 });
        end = addDays(start, 6);
        break;
      case "nextweek":
        start = addDays(startOfWeek(new Date(), { weekStartsOn: 1 }), 7);
        end = addDays(start, 6);
        break;
      default:
        return;
    }
    this.form.controls.create_date_from.setValue(start);
    this.form.controls.create_date_to.setValue(end);
  }
}
